import { PublicClientApplication ,LogLevel } from "@azure/msal-browser";
import store from "store/store";

class MSGraphAuthenticator {

    username = '';
    
    myMSALObj = false;

    constructor (){
        this.username = '';
        this.myMSALObj =  new PublicClientApplication(this.config);
    }


    config = {
        auth: {
            // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
            clientId: "23770d3c-f371-4f41-a66b-7a081fba054d",
            // Full directory URL, in the form of https://login.microsoftonline.com/<tenant-id>
            authority: "https://login.microsoftonline.com/3485b963-82ba-4a6f-810f-b5cc226ff898",
            // Full redirect URL, in form of http://localhost:3000
            redirectUri: store.getState().config.base_url
        },
        cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
        system: {	
            loggerOptions: {	
                loggerCallback: (level, message, containsPii) => {	
                    if (containsPii) {		
                        return;		
                    }		
                    switch (level) {		
                        case LogLevel.Error:		
                            console.error(message);		
                            return;		
                        case LogLevel.Info:		
                            console.info(message);		
                            return;		
                        case LogLevel.Verbose:		
                            console.debug(message);		
                            return;		
                        case LogLevel.Warning:		
                            console.warn(message);		
                            return;		
                        default:
                            console.warn(message);		
                            return;
                    }	
                }	
            }	
        }
    }

    loginRequest = {
        scopes: ["User.Read"]
    }

    tokenRequest = {
        scopes: ["User.Read", "Mail.Read"],
        forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
    }

    endpoint = {
        me: "https://graph.microsoft.com/v1.0/me"
    }

    handleResponse = (response) => {

        /**
         * To see the full list of response object properties, visit:
         * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#response
         */
        if (response !== null) 
        {
            this.username = response.account.username;
        } 
        else 
        {
            this.selectAccount();
        }
    }

    selectAccount = () => {

        /**
         * See here for more info on account retrieval: 
         * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
         */
    
        const currentAccounts = this.myMSALObj.getAllAccounts();
        if (currentAccounts.length === 0) 
        {
            return;
        } else if (currentAccounts.length > 1) {
            // Add choose account code here
            console.warn("Multiple accounts detected.");
        } else if (currentAccounts.length === 1) {
            this.username = currentAccounts[0].username;
            console.log('Only 1 account')
        }
    }

    signIn = () => {

        /**
         * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
         * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
         */
    
        this.myMSALObj.loginPopup(this.this.loginRequest)
            .then(this.handleResponse)
            .catch(error => {
                console.error(error);
            });
    }

    signOut = () => {

        /**
         * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
         * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
         */
    
        const logoutRequest = {
            account: this.myMSALObj.getAccountByUsername(this.username),
            postLogoutRedirectUri: this.config.auth.redirectUri,
            mainWindowRedirectUri: this.config.auth.redirectUri
        };
    
        this.myMSALObj.logoutPopup(logoutRequest);
    }

    getToken = ()  => {

        const requestingToken = function(resolve, reject){
            let request = this.loginRequest;
    
            /**
             * See here for more info on account retrieval: 
             * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
             */
            request.account = this.myMSALObj.getAccountByUsername(this.username);
            
            this.myMSALObj.acquireTokenSilent(request)
                .then((tokenResponse) => {
                    console.warn("silent token acquisition success");
                    resolve(tokenResponse);
                })
                .catch(error => {
                    console.warn("silent token acquisition fails. acquiring token using popup");
                    return this.myMSALObj.acquireTokenPopup(request)
                        .then((tokenResponse) => {
                            resolve(tokenResponse);
                        }).catch(error => {
                            reject(error);
                        });
                })
                .catch(function(error){
                    reject(error);
                })
        }

        return new Promise(requestingToken.bind(this));

    }
}

function msgraphCall(endpoint, token){
    const headers = new Headers();
    const bearer = `Bearer ${token}`;

    headers.append("Authorization", bearer);
    // headers.append("Content-type", 'image/jpeg');

    const options = {
        method: "GET",
        headers: headers
        
    };

    return new Promise((resolve, reject) => {

        fetch('https://graph.microsoft.com/v1.0' + endpoint, options)
            .then(response => {
                
                resolve(response, endpoint)

            })
            .catch(error => reject(error));
    });

}


export { MSGraphAuthenticator };
export default msgraphCall;